(function () {
    'use strict';

    angular.module('app.blogPostCategory', [
        // Angular modules 
        'ngRoute',
        'ngFileUpload'

        // Custom modules 

        // 3rd Party Modules

    ]);
})();